import React, { useEffect, useState } from 'react';
import './AgencyDatabase.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table, } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const AgencyDatabase = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const location = useLocation();
  const { siteName } = location.state;
  const [agencyData, setAgencyData] = useState([]);

  useEffect(() => {
      const encodedSiteName = encodeURIComponent(siteName);

      const endpoint = `${API_URL}/agency/?siteName=${encodedSiteName}`;
      fetch(endpoint)
        .then((response) => response.json())
        .then((data) => setAgencyData(data))
        .catch((error) => console.error(error));
  }, [location.state, siteName]);

  const fetchTasks = (filterValue) => {
    const encodedSiteName = encodeURIComponent(siteName);
    let endpoint;

     if (filterValue) {
      endpoint = `${API_URL}/agency/?siteName=${encodedSiteName}&filter=${filterValue}`;
    }
     else {
      endpoint = `${API_URL}/agency/?siteName=${encodedSiteName}`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setAgencyData(data))
      .catch((error) => console.error(error));
  };

  const getAgencyDetails = (name) => {
    const filteredAgency = agencyData.filter(agency => agency.name === name);
    navigate('/AgencyDetails', { state: { agencyDetails: filteredAgency[0] } });
  };

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

  const deleteAgency = async (name) => {
    try {
      const response = await axios.delete(API_URL + `/agency/${name}`);

      if (response.status === 204) {
        console.log('Agency deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting Agency');
      }
    } catch (error) {
      console.error(error);
    }
  };

 // =========== add agnecy start ================================================
 const [formData, setFormData] = useState({
  name: '',
  email: '',
  mobile: '',
  address: '',
  siteName: location.state.siteName,
  organization: '',
});

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value, siteName: location.state.siteName });
};

const handleSubmit = (e) => {
  e.preventDefault();
  fetch(API_URL + '/agency', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Form data sent successfully:', data);
      closeForm();
      fetchTasks();
    })
    .catch((error) => {
      console.error('Error sending form data:', error);
    });
};

// =========== end ===========================================================

      const columns = [
        {
          title: 'Index',
          dataIndex: 'Index',
          key: 'Index',
          width: '8%',
        },
        {
          title: 'Agency Name',
          dataIndex: 'Name',
          key: 'Name',
          width:'14%',
        },
        {
          title: 'Address',
          dataIndex: 'Address',
          key: 'Address',
          width:'21%',
        },
        {
          title: 'Organization',
          key: 'Organization',
          dataIndex: 'Organization',
        },
        {
          title: 'Phone No.',
          key: 'PhoneNo',
          dataIndex: 'PhoneNo',
        },
        {
          title: 'Email ID',
          dataIndex: 'EmailID',
          key: 'EmailID',
        },
        {
          title: 'Action',
          key: 'action',
          width: '10%',
          render: (_, record) => (
            <Space size="middle">
              <div onClick={() => getAgencyDetails(record.Name)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteAgency(record.Name)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
            </Space>
          ),
        },
      ];
     
      const dataa = agencyData.length > 0 ? agencyData.map((item, index) => ({
        key: index.toString(),
        Index: index + 1,
        Name: item.name || '',
        Address: item.address || '',
        Organization: item.organization || '',
        PhoneNo: item.mobile || '',
        EmailID: item.email,
      })) : [];

return( 
<div>
    <SideMenuBar></SideMenuBar>
        
    <div class="content">
          <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Directory</h3>  
          </div>
        
          <div className='row3'>
            <div className='searchBox'>
              <div class="column1_searchBox">
                <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
              </div>
              <div class="column2_searchBox">
                <input className='search_input1' placeholder='Search' onChange={(e) => {
              const text = e.target.value;
              fetchTasks(text);
            }}></input>
              </div>
            </div>
            <button onClick={openForm} className='add_agencies_btn_AgencyDatabase'> + Add Agencies</button>
          </div>
          {isFormOpen && (
        <>
          <div className="overlay_AgencyDatabase" onClick={closeForm}></div>
          <div className="popup-form_AgencyDatabase">
            <span className="close_AgencyDatabase" onClick={closeForm}>&times;</span>
            <p className='addAgency_popup_SiteDatabase'><b>Add Agency</b></p>
            {/* Your form content goes here */}
            <form>
            <div className='row4_AgencyDatabase'>
            <h3 className='siteName_h3_AgencyDatabase'>{siteName}</h3>
          </div>

          <div class="row5_AgencyDatabase">
            <div class="row5_column1_AgencyDatabase">
              <p>Agency Name</p>
              <input className='agencyName_input_AgencyDatabase' placeholder='Enter Agency Name' name='name'
              value={formData.name}
              onChange={handleInputChange}></input>

              <p>Address</p>
              <textarea className='address_input_AgencyDatabase' placeholder='Enter Address' name='address'
              value={formData.address}
              onChange={handleInputChange}></textarea><br/>

            </div>
  
            <div class="row5_column2_AgencyDatabase">
              <p>Organization</p>
              <input className='organization_input_AgencyDatabase' placeholder='Enter Organization' name='organization'
              value={formData.organization}
              onChange={handleInputChange}></input>

              <p>Phone No.</p>
              <input className='phoneNo_input_AgencyDatabase' placeholder='Enter Phone No.' name='mobile'
              value={formData.mobile}
              onChange={handleInputChange}></input>

              <p>Email ID</p>
              <input className='role_input_AgencyDatabase' placeholder='Enter Email ID' name='email'
              value={formData.email}
              onChange={handleInputChange}></input>

              <button className='update_btn_input_AgencyDatabase' onClick={handleSubmit}>Update</button>
            </div>
          </div>       
            </form>
          </div>
        </>
      )}

          

          <div className='row6_AgencyDatabase'>
              <p>Agency Database</p>
          </div>

          <div className='table_AgencyDatabase'>
            <Table 
              columns={columns} 
              dataSource={dataa} 
              scroll={{ y: 240 }}
              pagination={false}
            />
          </div>  
          
        
    <br/><br/>
    </div>
</div>
 )
}

export default AgencyDatabase;